var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Dashboard"},[_c('Dashboard',{attrs:{"msg":"Jaja hier ein Text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }